import { getAction } from "@/api/common";

const CURRENCY_CACHE_KEY = "appCurrencyMap";

const state = {
  currencyList: [],
  currencyMap: JSON.parse(localStorage.getItem(CURRENCY_CACHE_KEY)) || {},
};

const mutations = {
  SET_CURRENCY_LIST: (state, list) => {
    state.currencyList = list;
  },
  SET_CURRENCY_MAP(state, list) {
    const simpleMap = list.reduce((acc, cur) => {
      // 结果类似于 { "USD": "$", "SGD": "S$" }
      acc[cur.currency] = cur.symbol || cur.currency;
      return acc;
    }, {});
    // Object.freeze 用于冻结对象，防止后续修改对象
    state.currencyMap = Object.freeze(simpleMap);
    localStorage.setItem(CURRENCY_CACHE_KEY, JSON.stringify(simpleMap));
  },
};

const actions = {
  fetchCurrencyList({ commit }) {
    return new Promise((resolve, reject) => {
      getAction("/currency/getList")
        .then(res => {
          commit("SET_CURRENCY_LIST", res.data || []);
          commit("SET_CURRENCY_MAP", res.data || []);
          resolve(res.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
